// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormAddActivity } from '../../forms/FormAddActivity/FormAddActivity';

// types
import { PlanningActivity } from '../../../@types';

// Props

export interface DialogAddActivityProps {
	activity?: PlanningActivity | null;
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
	parentActivityId?: number;
	preSelectedCategoryId?: number;
	preSelectedComponentId?: number;
	preSelectedWorkPlanId?: number;
}

// Component

export const DialogAddActivity = ({
	activity,
	isOpen,
	onClose,
	onSuccess,
	parentActivityId,
	preSelectedCategoryId,
	preSelectedComponentId,
	preSelectedWorkPlanId,
}: DialogAddActivityProps) => {
	// hooks
	const { t } = useTranslation();

	// derived
	const isEditMode = Boolean(activity);

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: parentActivityId
						? t('spendPlan.addSubActivity')
						: isEditMode
							? t('spendPlan.saveActivity')
							: t('spendPlan.addActivity'),
					form: isEditMode ? 'form-edit-activity' : 'form-add-activity',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={800}
			onClose={onClose}
			title={{
				children: parentActivityId
					? t('spendPlan.addSubActivity')
					: isEditMode
						? t('spendPlan.editActivity')
						: t('spendPlan.addNewActivity'),
				variant: 'h3',
			}}>
			<FormAddActivity
				activity={activity}
				onClose={onClose}
				onSuccess={onSuccess}
				parentActivityId={parentActivityId}
				preSelectedCategoryId={preSelectedCategoryId}
				preSelectedComponentId={preSelectedComponentId}
				preSelectedWorkPlanId={preSelectedWorkPlanId}
				setIsLoading={setIsLoading}
			/>
		</DialogActions>
	);
};
